// Comprehensive waste sorting data for Lithuania
// Data source: gamtosateitis.lt and zaliasistaskas.lt
import { additionalWasteItems } from './expandedWasteData';

export const wasteItems = [
  {
    name: 'Aerozoliniai flakonai',
    container: 'Plastikas',
    description: 'Tušti kūno priežiūros priemonių, plaukų lako ar putų, kosmetikos, indų plovimo, skalbimo bei valymo priemonių aerozoliniai flakonai turi būti rūšiuojami, atsižvelgiant į medžiagą, iš kurios yra pagaminti.\n\nJei flakonuose yra priemonių likučių, mesti į konteinerius jų negalima, juos būtina pristatyti į atliekų surinkimo aikšteles.',
  },
  {
    name: 'Akiniai',
    container: 'Mišrios atliekos',
    description: 'Naudoti nebetinkamus, sulūžusius akinius meskite į mišriųjų atliekų konteinerį. Akinių stiklui galioja ta pati taisyklė – jo mesti į stiklo konteinerį negalima.',
  },
  {
    name: 'Aliumininės kremų tūtelės',
    container: 'Plastikas',
    description: 'Aliumininė kremo ar balzamo tūtelė turi būti metama į pakuočių konteinerius, skirtus bendrai popieriui, plastikui ir metalui.',
  },
  {
    name: 'Antifrizo, tepalų pakuotės',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
    additionalInfo: 'Adresų paieška: https://aaa.lrv.lt',
  },
  {
    name: 'Atvirukus',
    container: 'Popierius',
    description: 'Atvirukus išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nIšmetamas popierius, kartonas ir jų pakuotės turi būti švarios.',
  },
  {
    name: 'Ausų krapštukai',
    container: 'Mišrios atliekos',
    description: 'Meskite į mišriųjų atliekų konteinerį.',
  },
  {
    name: 'Banko kortelės',
    container: 'Mišrios atliekos',
    description: 'Banko kortelių mesti į perdirbamų atliekų konteinerį nederėtų ir dėl saugumo priežasčių. Nebenaudojamas banko korteles rekomenduojama sukarpyti, susmulkinti dėl asmeninių duomenų.\n\nGalite grąžinti jas išdavusiam bankui, kad šis kortelę atsakingai sunaikintų.',
  },
  {
    name: 'Blizgūs saldainių popierėliai',
    container: 'Plastikas',
    description: 'Meskite į plastiko arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui. Šie popierėliai – kombinuotoji pakuotė, ne popieriaus atliekos.',
  },
  {
    name: 'Buitinių priemonių plastikinė tara',
    container: 'Plastikas',
    description: 'Plastikines atliekas išmeskite į plastikui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nPerdirbamos plastiko pakuotės yra pažymėtos perdirbimo simboliu.',
    additionalInfo: 'Rekomenduojama pašalinti skysčių likučius',
  },
  {
    name: 'Cigarečių nuorūkos',
    container: 'Mišrios atliekos',
    description: 'Neperdirbamos. Meskite jas į mišriųjų atliekų konteinerius.',
  },
  {
    name: 'Dantų pastos tūbelę',
    container: 'Plastikas',
    description: 'Dantų pastos tūbelė turi būti metama į plastiko arba pakuočių, skirtų popieriui, plastikui ir metalui konteinerius.',
  },
  {
    name: 'Dantų šepetėlius',
    container: 'Mišrios atliekos',
    description: 'Meskite į mišrių atliekų konteinerį. Dantų šepetėliai yra netinkami perdirbti, nes jų sudėtyje yra daug įvairių skirtingų plastikų ir kitų medžiagų.',
  },
  {
    name: 'Dažų, aerozolio flakonus',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Dezinfekcinių priemonių butelius',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Dėžutes maistui išsinešimui',
    container: 'Plastikas',
    description: 'Įvertinkite, iš kokios medžiagos tos dėžutės pagamintos. Dažniausiai tokios dėžutės gaminamos iš putplasčio, tad jas išmeskite į plastikui skirtus konteinerius.\n\nRekomenduojama pašalinti likusius maisto likučius.',
  },
  {
    name: 'Dokumentų segtuvus su metalinėmis dalimis',
    container: 'Plastikas',
    description: 'Dokumentų segtuvus su metalinėmis dalimis galima mesti tik į pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Dovanų maišelius ir dėžutes',
    container: 'Popierius',
    description: 'Dovanų maišelius ir dėžutes išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nGali būti su lipnia juostele. Dėžutes išlankstykite, suspauskite.',
  },
  {
    name: 'Džiuto maišeliai',
    container: 'Plastikas',
    description: 'Džiuto (medžiaginiai) maišeliai laikomi pakuote, jei jie buvo naudojami prekei supakuoti. Tokiu atveju juos reikia mesti į pakuočių konteinerį, skirtą bendrai popieriui, plastikui ir metalui.',
  },
  {
    name: 'Elektros lemputes, baterijas',
    container: 'Pavojingos',
    description: 'Lemputes kartu su baterijomis, elektronikos prietaisais reikėtų rūšiuoti atskirai ir pristatyti į elektronikos atliekų surinkimo vietas.',
  },
  {
    name: 'Flomasterius, spalvotus pieštukus',
    container: 'Mišrios atliekos',
    description: 'Kanceliarinės priemonės – nėra pakuotė. Jie gaminami iš skirtingų ir dažniausiai neperdirbamų plastikų. Jas meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Foliją',
    container: 'Plastikas',
    description: 'Jei folija yra pakankamai švari, pavyzdžiui, suvalgius į ją suvyniotus sumuštinius, ji gali keliauti į plastiko atliekų konteinerį.\n\nTačiau tuo atveju, kai folijoje buvo kepti maisto produktai ir ji yra suteršta maisto ar pelenų likučiais, ją išmeskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Gėrimų ir konservų skardines',
    container: 'Plastikas',
    description: 'Metalines pakuotes reikia mesti į plastiko arba pakuočių, skirtų popieriui, plastikui ir metalui konteinerius.\n\nRekomenduojama pašalinti skysčių ar maisto likučius.',
  },
  {
    name: 'Gumines pirštines',
    container: 'Mišrios atliekos',
    description: 'Šias atliekas reikia mesti į mišrių atliekų konteinerį.',
  },
  {
    name: 'Gyvūnų maisto pakuotes',
    container: 'Plastikas',
    description: 'Plastikines / popierines ar kombinuotas gyvūnų maistui skirtas pakuotes išmeskite į plastikui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nRekomenduojama pašalinti maisto likučius.',
  },
  {
    name: 'Higienos priemonių pakuotės',
    container: 'Plastikas',
    description: 'Pakuotės nuo prausiklio, kremo, muilo, šampūno, dušo želės, dantų pastos, lūpų balzamo ir kitų higienos priemonių turi būti rūšiuojamos, atsižvelgiant į medžiagą.\n\nSvarbu, kad tokios pakuotės būtų tuščios ir neišteptų kitų atliekų.',
  },
  {
    name: 'Kapinių žvakės',
    container: 'Mišrios atliekos',
    description: 'Dažniausiai šalia kapinių yra specialūs, kapinių atliekoms skirti konteineriai. Jeigu jų nėra, žvakes meskite į mišriųjų atliekų konteinerius.',
  },
  {
    name: 'Kartonines maisto pakuotes',
    container: 'Popierius',
    description: 'Kartonines maisto pakuotes išmeskite į popieriui ir kartonui skirtus konteinerius arba į pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nIšmetamas popierius, kartonas ir jų pakuotės turi būti švarios.',
  },
  {
    name: 'Kavos kapsules',
    container: 'Mišrios atliekos',
    description: 'Kavos kapsulės kartu su visu turiniu turi būti metamos į mišrių atliekų konteinerį. Šios kapsulės nėra gamtai draugiškas sprendimas – tai kaip ir vienkartiniai indai – nėra perdirbama.',
  },
  {
    name: 'Kempinė',
    container: 'Mišrios atliekos',
    description: 'Meskite į mišriųjų atliekų konteinerį.',
  },
  {
    name: 'Kepimo popierius',
    container: 'Mišrios atliekos',
    description: 'Meskite į mišriųjų atliekų konteinerį. Kepimo popierius – ne pakuotė, ne makulatūra, jis padengtas silikonu, be to, išsiriebaluoja nuo maisto produktų, todėl netinka perdirbti.',
  },
  {
    name: 'Keramiką',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Kiaušinių pakuotes',
    container: 'Plastikas',
    description: 'Kartonines kiaušinių pakuotės gali būti metamos į popieriui, o plastikinės – į plastikui konteinerį. Jei konteineris skirtas bendrai popieriui, plastikui ir metalui, tai į jį meskite ir kartonines, ir plastikines kiaušinių pakuotes.',
  },
  {
    name: 'Knygas',
    container: 'Popierius',
    description: 'Knygas išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nSvarbu tai, kad knygos nebūtų supelijusios, drėgnos. Jei knygos yra su kietu viršeliu, rekomenduojama kietą viršelį atskirti ir jį mesti į mišrių komunalinių atliekų konteinerį.',
  },
  {
    name: 'Kompaktinius diskus',
    container: 'Mišrios atliekos',
    description: 'Šias elektronines atliekas meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Kosmetikos pakuotės',
    container: 'Plastikas',
    description: 'Visiškai ištuštintą, iki galo išnaudotą (išspaustą) pakuotę meskite į plastiko arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Kremo tūbelė',
    container: 'Plastikas',
    description: 'Visiškai ištuštintą (išspaustą) plastikinę pakuotę meskite į plastiko arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui. Produkto likučius reikia išmesti į mišriųjų atliekų konteinerį.',
  },
  {
    name: 'Krištolą',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Laikraščius ir žurnalus',
    container: 'Popierius',
    description: 'Laikraščius ir žurnalus išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nIšmetamas popierius turi būti švarus. Sąvaržėlių išsegti nereikia.',
  },
  {
    name: 'Langų stiklus',
    container: 'Pavojingos',
    description: 'Šių atliekų negalima palikti prie stiklui skirtų konteinerių, jas būtina pristatyti į didelių gabaritų atliekų tvarkymo aikštelę.\n\nLangų stiklas ir stiklo paketai yra selektyvūs, metalizuoti, tai yra statybinės, ne pakuočių atliekos.',
  },
  {
    name: 'Maišelio spaustukas',
    container: 'Plastikas',
    description: 'Meskite į plastiko arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui. Tai – pakuotės dalis.',
  },
  {
    name: 'Medicinos atliekas',
    container: 'Mišrios atliekos',
    description: 'Dėl buityje susidariusių medicininių atliekų priėmimo galite pasiteirauti savo regiono didelių gabaritų atliekų tvarkytojo arba – meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Metalinius dangtelius',
    container: 'Plastikas',
    description: 'Metalines pakuotes reikia mesti į plastiko arba pakuočių, skirtų popieriui, plastikui ir metalui konteinerius.',
  },
  {
    name: 'Molinė gėrimų tara',
    container: 'Plastikas',
    description: 'Moliniai ar keramikiniai buteliai, skirti gėrimams (pvz., midui, balzamui), yra laikomi pakuote. Juos reikia mesti į pakuočių konteinerį, skirtą bendrai popieriui, plastikui ir metalui.',
  },
  {
    name: 'Pakavimo popierių',
    container: 'Popierius',
    description: 'Pakavimo popierių išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nGali būti su lipnia juostele.',
  },
  {
    name: 'Pergamentinį popierių',
    container: 'Mišrios atliekos',
    description: 'Šias atliekas reikia mesti į mišrių atliekų konteinerį.',
  },
  {
    name: 'Picos dėžutes',
    container: 'Popierius',
    description: 'Picos kartoninės dėžės dalį, suteptą riebalais, maistu meskite į buitinių atliekų konteinerį, o švarią – į konteinerį, skirtą popieriui / kartonui.',
  },
  {
    name: 'Piešinius',
    container: 'Popierius',
    description: 'Piešinius išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Plastikines gėles',
    container: 'Mišrios atliekos',
    description: 'Dirbtinės gėlės nėra pakuotė. Jos gaminamos iš skirtingų ir dažniausiai neperdirbamų plastikų, todėl jas meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Plastikines maisto pakuotes',
    container: 'Plastikas',
    description: 'Plastikines atliekas išmeskite į plastikui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nPerdirbamos plastiko pakuotės yra pažymėtos perdirbimo simboliu.',
  },
  {
    name: 'Plastikinius butelius',
    container: 'Plastikas',
    description: 'Plastikinius butelius reikia mesti į plastikui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nButelius užsukite.',
  },
  {
    name: 'Polietileno maišelius',
    container: 'Plastikas',
    description: 'Plastikines atliekas išmeskite į plastikui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Popierines servetėles',
    container: 'Mišrios atliekos',
    description: 'Panaudotos popierinės servetėlės, rankšluosčiai nebetinkami perdirbti, jie yra drėgni, gali būti užteršti bakterijomis. Meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Popierinius krepšius',
    container: 'Popierius',
    description: 'Popierinius krepšius išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Porcelianą',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Putplastį',
    container: 'Plastikas',
    description: 'Tai – pakavimo medžiaga, gali būti metama į plastiko pakuočių atliekoms skirtą konteinerį.',
  },
  {
    name: 'Rašomąjį popierių',
    container: 'Popierius',
    description: 'Rašomąjį popierių išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nSąvaržėlių išsegti nereikia. Gali būti su lipnia juostele.',
  },
  {
    name: 'Saldainių popierėlius',
    container: 'Plastikas',
    description: 'Šias pakuotes priskiriame kombinuotai pakuotei, tad juos reikia mesti į plastikui ir kombinuotoms pakuotėms skirtus atliekų rūšiavimo konteinerius.',
  },
  {
    name: 'Sauskelnes',
    container: 'Mišrios atliekos',
    description: 'Šias atliekas reikia mesti į mišrių atliekų konteinerį. Sauskelnės – neperdirbamos.',
  },
  {
    name: 'Skardinės',
    container: 'Plastikas',
    description: 'Meskite į plastiko arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nRekomenduojama pašalinti maisto ir skysčių likučius.',
  },
  {
    name: 'Skrajutes ir lankstinukus',
    container: 'Popierius',
    description: 'Skrajutes ir lankstinukus išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Skutimosi peiliukus',
    container: 'Mišrios atliekos',
    description: 'Meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Stiklainius',
    container: 'Stiklas',
    description: 'Stiklainius be dangtelių reikia mesti į stiklo pakuotėms skirtą konteinerį.\n\nIšmetamos stiklo pakuotės turi būti švarios. Etikečių nulupti nereikia.',
  },
  {
    name: 'Stiklinius butelius',
    container: 'Stiklas',
    description: 'Stiklinius butelius reikia mesti į stiklo pakuotėms skirtą konteinerį.\n\nIšmetamos stiklo pakuotės turi būti švarios. Etikečių nulupti nereikia.',
  },
  {
    name: 'Stiklo duženas',
    container: 'Stiklas',
    description: 'Stiklo duženas ir atraižas, stiklainius be dangtelių reikia mesti į stiklo pakuotėms skirtą konteinerį.',
  },
  {
    name: 'Tablečių pakuotė',
    container: 'Plastikas',
    description: 'Iš aliuminio ir plastiko sudarytas tablečių "lapelis" yra kombinuotoji pakuotė, todėl meskite ją į plastiko arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Tapetus',
    container: 'Pavojingos',
    description: 'Šių atliekų nemeskite į rūšiavimui skirtus konteinerius. Juos reikia pristatyti į specialias didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Tekstilę',
    container: 'Mišrios atliekos',
    description: 'Meskite į tekstilės atliekoms skirtą konteinerį. Juos reikia sukrauti į maišus. Išmetami drabužiai ir tekstilė turi būti švarūs.',
    additionalInfo: 'Surinktos tekstilės atliekos vežamos perdirbėjams, kur jos yra perrūšiuojamos.',
  },
  {
    name: 'TetraPak pakuotes',
    container: 'Plastikas',
    description: 'Plastikines arba kombinuotas pakuotes išmeskite į plastikui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.\n\nRekomenduojama suspaudyti pakuotes.',
  },
  {
    name: 'Traškučių pakelius',
    container: 'Plastikas',
    description: 'Šias pakuotes priskiriame kombinuotai, kitaip vadinamai daugiasluoksnei pakuotei, tad juos reikia mesti į plastikui ir kombinuotoms pakuotėms skirtus atliekų rūšiavimo konteinerius.',
  },
  {
    name: 'Tualetinį popierių',
    container: 'Mišrios atliekos',
    description: 'Panaudotas tualetinis popierius netinkamas perdirbti. Jis gali būti užterštas bakterijomis. Meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Vaistus',
    container: 'Pavojingos',
    description: 'Vaistai turėtų būti priduoti į vaistinę. Vaistininkai priima visus receptinius, nereceptinius ir net veterinarinius vaistus.\n\nVisos kitos atliekos rūšiuojamos įprastai – popierinė pakuotė keliauja į popieriaus konteinerį.',
  },
  {
    name: 'Vatos lapeliai',
    container: 'Mišrios atliekos',
    description: 'Meskite į mišriųjų atliekų konteinerį.',
  },
  {
    name: 'Veidrodžius',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Vienkartines servetėles',
    container: 'Mišrios atliekos',
    description: 'Išrūšiuotos popieriaus atliekos privalo būti švarios, neužterštos riebalais. Panaudotos nosinaitės yra suteptos, drėgnos. Meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Vienkartinius kavos puodelius',
    container: 'Plastikas',
    description: 'Šias pakuotes priskiriame kombinuotai pakuotei, tad juos reikia mesti į plastikui ir kombinuotoms pakuotėms skirtus atliekų rūšiavimo konteinerius.',
  },
  {
    name: 'Vienkartinius skustukus',
    container: 'Mišrios atliekos',
    description: 'Meskite į mišrių atliekų konteinerį.',
  },
  {
    name: 'Vokus',
    container: 'Popierius',
    description: 'Vokus išmeskite į popieriui ir kartonui skirtus konteinerius arba pakuočių konteinerius, skirtus popieriui, plastikui ir metalui.',
  },
  {
    name: 'Vyno kamščius',
    container: 'Mišrios atliekos',
    description: 'Medinius kamščius galite mesti į bendrą atliekų konteinerį, nes jie lengvai suyra, tačiau plastikinius meskite į plastiko konteinerį.',
  },
  {
    name: 'Žaislus iš plastiko',
    container: 'Pavojingos',
    description: 'Šias atliekas tvarkykite kaip didelių gabaritų atliekas – jas reikia pristatyti į didelių gabaritų atliekų aikšteles.',
  },
  {
    name: 'Žiebtuvėlius',
    container: 'Mišrios atliekos',
    description: 'Jei žiebtuvėlis yra visiškai tuščias (be dujų) – jį galima mesti į buitinių atliekų konteinerį.\n\nJei jame liko degiųjų cheminių medžiagų – saugiausia būtų tokius žiebtuvėlius pristatyti į stambiagabaritinių atliekų aikštelę kaip pavojingas atliekas.',
  },
  ...additionalWasteItems,
];
